import { render, staticRenderFns } from "./common-upload-Enclosure.vue?vue&type=template&id=1cb1b937&"
import script from "./common-upload-Enclosure.vue?vue&type=script&lang=js&"
export * from "./common-upload-Enclosure.vue?vue&type=script&lang=js&"
import style0 from "./common-upload-Enclosure.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports